import Vue from 'vue';
import Router from 'vue-router';
import Create from '@/pages/CharacterSheets/Create.vue';
import Edit from '@/pages/CharacterSheets/Edit.vue';
import Read from '@/pages/CharacterSheets/Read.vue';
import Mypage from '@/pages/Mypage/index.vue';
import Signup from '@/pages/Signup/index.vue';
import Signin from '@/pages/Signin/index.vue';
import firebase from 'firebase';

Vue.use(Router);

export const router = new Router({
  routes: [
    {
      path: '*',
      redirect: 'signin',
      meta: { title: 'tabless' },
    },
    {
      path: '/character/create/',
      name: 'Create',
      component: Create,
      meta: {
        title: 'tabless Character Create',
        requiresAuth: true,
      },
    },
    {
      path: '/character/:id',
      name: 'Read',
      component: Read,
      meta: {
        title: 'tabless Character Read',
        requiresAuth: false,
      },
    },
    {
      path: '/character/:id/edit',
      name: 'Edit',
      component: Edit,
      meta: {
        title: 'tabless Character Edit',
        requiresAuth: true,
      },
    },
    {
      path: '/',
      name: 'Mypage',
      component: Mypage,
      meta: {
        title: 'tabless Mypage',
        requiresAuth: true,
      },
    },
    {
      path: '/signup',
      name: 'Signup',
      component: Signup,
      meta: {
        title: 'tabless Signup',
        requiresAuth: false,
      },
    },
    {
      path: '/signin',
      name: 'Signin',
      component: Signin,
      meta: {
        title: 'tabless Signin',
        requiresAuth: false,
      },
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requireAuth);
  if (requiresAuth) {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        next();
      } else {
        next({
          path: '/signin',
          query: { redirect: to.fullPath },
        });
      }
    });
  } else {
    next();
  }
});
